function FourOFour() {
    return (
        <div>
            <br />
            <br />
            <br />
            <br />
            <h1>Page does not exist!</h1>
        </div>
    );
};

export default FourOFour;
